import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-footer.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import '../../base/outline-icon/outline-icon';
import '../se-button/se-button';
import '../se-heading/se-heading';
import '../se-logo/se-logo';

/**
 * The SeFooter component
 * @element se-footer
 * @slot main - main nav markup from drupal.
 * @slot social - se-social-link component.
 */
@customElement('se-footer')
export class SeFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  @property({ type: String, attribute: 'button-url' })
  buttonUrl: string;

  @property({ type: String, attribute: 'button-text' })
  buttonText: string;

  @property({ type: String, attribute: 'footer-legal' })
  footerLegal: string;

  render(): TemplateResult {
    const currentYear = new Date().getFullYear();
    return html`
      <footer class="footer">
        <se-container>
          <div class="footer-main-content">
            <div class="footer-logo">
              <se-logo variant="dark"></se-logo>
            </div>
            <slot name="main"></slot>
            <div class="footer-social">
              <se-heading level="h2" level-size="h6" level-style="medium"
                >STAY CONNECTED</se-heading
              >
              <ul class="footer-social--list">
                <slot name="social"></slot>
              </ul>
              ${this.buttonText || this.buttonUrl
                ? html`
                    <se-button
                      variant="tertiary"
                      size="small"
                      button-url=${this.buttonUrl}
                    >
                      ${this.buttonText}
                      <outline-icon
                        color="brand-secondary-2"
                        slot="left"
                        library="system"
                        name="mail"
                      ></outline-icon>
                    </se-button>
                  `
                : nothing}
            </div>
          </div>
          ${this.footerLegal
            ? html` <div class="footer-legal">
                Copyright &copy; ${currentYear} ${this.footerLegal}
              </div>`
            : nothing}
        </se-container>
      </footer>
    `;
  }
}
